module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPlaceHolder) ? _c('div', {
    staticStyle: {
      "height": "35px",
      "visibility": "hidden"
    }
  }, [_vm._v("占位")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfbe420","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/components/GcFooterPlaceholder.vue
// module id = 1652
// module chunks = 8